import { Component } from '@angular/core';

@Component({
  selector: 'app-brand-section',
  standalone: true,
  template: `
    <section class="landing-section">
      <div class="landing-inner">
        <div class="record-grid">
          <div class="profile-card reveal">
            <div class="pf-banner">
              <div class="pf-url">
                <span class="live"></span>kaizenic.ai/u/maya
              </div>
            </div>
            <div class="pf-body">
              <img
                class="pf-photo"
                src="/images/maya-rivera.jpg"
                alt="Maya Rivera"
                width="92"
                height="92"
              />
              <div class="pf-name">Maya Rivera</div>
              <div class="pf-role">Forward Deployed Engineer</div>
              <p class="pf-bio">
                "I don't collect certificates. I ship where it matters."
              </p>
              <div class="pf-pills">
                <span class="pf-pill">Learns by building</span>
                <span class="pf-pill">Deep evening sessions</span>
                <span class="pf-pill streak">47-day streak</span>
              </div>
              <div class="pf-journey">
                <div class="pf-era-period">
                  2026<span class="pf-badge-current">Current</span>
                </div>
                <div class="pf-era">
                  <div class="pf-era-header">
                    Deploying solutions in the field
                  </div>
                  <div class="pf-era-skills">
                    <span class="pf-sub-label">Leveled up in</span>
                    <div class="pf-chips">
                      <span class="pf-chip">Technical discovery</span>
                      <span class="pf-chip">Rapid prototyping</span>
                      <span class="pf-chip">On-site delivery</span>
                    </div>
                  </div>
                  <div class="pf-kai">
                    <span class="k">KΛI</span>
                    <span class="t"
                      >Maya doesn't wait for perfect specs — she embeds,
                      listens, and ships. Three customer deployments and
                      counting.</span
                    >
                  </div>
                </div>
              </div>
              <div class="pf-links">
                <a class="pf-link" href="#">↗ GitHub</a>
                <a class="pf-link" href="#">↗ Portfolio</a>
                <a class="pf-link" href="#">↗ Writing</a>
              </div>
            </div>
          </div>

          <div class="reveal" data-delay="1">
            <div class="landing-kicker">
              <span class="brush"></span>Your brand
            </div>
            <h2 class="landing-h2">
              Kaizenic shows <span class="accent">your growth.</span>
            </h2>
            <p class="landing-sub">
              You focus on growing. KΛI writes the story — each step, each
              build, each quiet breakthrough becomes part of a living profile.
              Not a résumé. Not a highlight reel. Just what happened.
            </p>
            <p class="brand-line">
              Your brand. <span class="accent">One link.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  `,
  styleUrl: './brand-section.component.scss',
})
export class BrandSectionComponent {}
